import React from "react"
import { FormContainer, Worksheet, LabeledInput } from "uikit"
import { Input, Dropdown } from "semantic-ui-react"
import { Footer } from "./Footer"
import { carPropertySchema } from "components/properties/carPropertySchema"
import { useStore } from "store"

const CarPropertyForm = ({
  data: {
    fields: { description, value, model_year },
    isModified,
    onSubmit,
    isPending,
    hasError,
    error
  },
  submitLabel = "Done",
  submitHeader = "",
  onDelete,
  isNew,
  autoLoanAccount
}) => {
  const confirmText = autoLoanAccount ? (
    <span>
      Deleting this property will also delete its auto loan.
      <strong> You cannot undo this action.</strong>
    </span>
  ) : (
    <span>
      If you proceed, you will permanently remove this account.
      <strong>YOU CANNOT UNDO THIS ACTION.</strong>
    </span>
  )
  let currentYear = new Date().getFullYear()
  let yearOptions = [...Array(31).keys()].map(key => {
    let year = currentYear - key + ""
    return { text: year, value: year }
  })
  return (
    <Worksheet error={error}>
      <Worksheet.Body>
        <Worksheet.Row
          label="What do you want to call this car?"
          description="A short name or label we can use to refer to this property as we work together."
          paddedField
        >
          <Worksheet.Field error={description.error}>
            <Input {...description} autoComplete="off" />
          </Worksheet.Field>
        </Worksheet.Row>
        <Worksheet.Row
          label="What is the current estimated trade-in/sale value?"
          paddedField
        >
          <Worksheet.Field error={value.error}>
            <LabeledInput
              {...value}
              label=""
              iconText="$"
              iconPosition="left"
              placeholder="0"
            />
          </Worksheet.Field>
        </Worksheet.Row>
        <Worksheet.Row label="What is the model year of the car?" paddedField>
          <Worksheet.Field error={model_year.error}>
            <Dropdown
              {...model_year}
              search
              selection
              options={yearOptions}
              fluid
            />
          </Worksheet.Field>
        </Worksheet.Row>
      </Worksheet.Body>
      <Footer
        deleteLabel="Delete Property"
        isNew={isNew}
        deleteText={confirmText}
        onDelete={onDelete}
        submitLabel={submitLabel}
        onSubmit={onSubmit}
        isModified={isModified}
        error={error}
      />
    </Worksheet>
  )
}

const CarPropertyFormContainer = FormContainer(
  carPropertySchema,
  (fields, ...form) => {}
)(CarPropertyForm)

const CarProperty = ({ household, property, ...formProps }) => {
  const [accounts] = useStore("householdAccounts", household.id)

  const isNew = property === null
  const values = isNew ? {} : property
  const autoLoanAccounts = Object.values(accounts).filter(
    ({ type }) => type === "autoloan"
  )
  const autoLoanAccount = autoLoanAccounts.find(
    account => account.property_id === values.id
  )
  return (
    <CarPropertyFormContainer
      {...{
        values,
        autoLoanAccount,
        ...formProps
      }}
    />
  )
}

export default CarProperty
